module.exports = __webpack_public_path__ + "img/tags-branded-icon.dd396bfa.png";